import { atom, selector, selectorFamily } from 'recoil';
import { Asset } from '../types/asset';
import { isDevice } from '../utils/currentStates';

export const searchAssetState = atom({
  key: 'app.client.assets.search',
  default: '',
});

export const assetsState = atom<Asset[] | undefined>({
  key: 'app.client.assets',
  default: undefined,
});

export const assetIdsState = selector<string[] | undefined>({
  key: 'app.client.assetIds',
  get: ({ get }) => {
    const assets = get(assetsState);
    if (!assets) return;
    return assets.map((asset) => asset._id);
  },
});

export const filteredAssetsState = selector<Asset[] | undefined>({
  key: 'app.client.assets.filtered',
  get: ({ get }) => {
    const assets = get(assetsState);
    if (!assets) return;
    let filteredAssets = [...assets];

    const search = get(searchAssetState);

    if (search) {
      filteredAssets = filteredAssets.filter((asset) => {
        if (
          asset.label?.toLowerCase().includes(search.toLowerCase()) ||
          asset.vehicle?.licensePlate?.toLowerCase().includes(search.toLowerCase()) ||
          asset.container?.identifier?.toLowerCase().includes(search.toLowerCase())
        )
          return true;
        return false;
      });
    }

    return filteredAssets;
  },
});

export const assetState = selectorFamily<Asset | undefined, string>({
  key: 'app.client.asset',
  get:
    (id) =>
    ({ get }) => {
      const assets = get(assetsState);
      if (!assets) return;
      return assets.find((asset) => asset._id === id);
    },
});

export const assetStateByIdent = selectorFamily<Asset | undefined, string>({
  key: 'app.client.asset',
  get:
    (ident) =>
    ({ get }) => {
      const assets = get(assetsState);
      if (!assets) return;
      return assets.find((asset) => (isDevice(asset.device) ? asset.device.ident === ident : asset.device === ident));
    },
});
